import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../services/api';
import { projectKeys } from './useProjects';
import type { ProfiloFinanziario, CreateProfiloFinanziarioInput } from '../types';

export function useSaveProfiloFinanziario() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateProfiloFinanziarioInput) =>
      api.post<ProfiloFinanziario>('/profilo-finanziario', data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: projectKeys.detail(variables.projectId),
      });
    },
  });
}
